<template>
    <div
        :class="{
            'app-index': true,
            'app-index--sidebar': hasSidebar
        }"
    >
        <keep-alive v-if="hasSidebar">
            <router-view name="sidebar" class="app-index__sidebar" />
        </keep-alive>
        <div class="app-index__main">
            <router-view :key="$route.fullPath" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Index',
    computed: {
        hasSidebar() {
            return this.$route.matched.some(record => record.components && record.components.sidebar);
        }
    }
};
</script>

<style lang="scss" scoped>
.app-index {
    min-height: 100%;
    &--sidebar {
        display: flex;
        .app-index__main {
            flex: 1 1 100%;
            min-width: 0;
        }
    }
}

.app-index__sidebar {
    width: 18rem;
    flex-shrink: 0;
    background: var(--v-background-darken2);
}
</style>
